import {
  DescriptiveBlock,
  DescriptiveBlockProps,
} from "./descriptiveBlock/DescriptiveBlock";
import styles from "./DescriptiveBlockList.module.scss";

export type DescriptiveBlockListProps = {
  descriptiveBlocks: DescriptiveBlockProps[];
};

export const DescriptiveBlockList = ({
  descriptiveBlocks,
}: DescriptiveBlockListProps) => (
  <div className={styles.container}>
    {descriptiveBlocks.map((descriptiveBlock, index) => (
      <DescriptiveBlock {...descriptiveBlock} key={index} />
    ))}
  </div>
);
